// src/component/homeSlidesData.js
// Локальные импорты — как в СтарыйHome.jsx (надёжно, не блокируется адблоками)
import Xiaomi14t from "./Image/xiaomi14tpro.mp4";
import Xiaomi15 from "./Image/xiaomi15.mp4";
import X20Pro from "./Image/1356_X20-max.mp4";
import Watch2 from "./Image/Watch2.mp4";
import Redmi14 from "./Image/RedmiNote14.mp4";

// Если нужно — можно добавить poster для первого слайда:
// import poster14t from "./images/xiaomi14tpro-poster.jpg";

const slides = [
  {
    type: "video",
    src: Xiaomi14t,
    // poster: poster14t,
    title: "Xiaomi 14T",
    description: "Потрясающая камера Leica для создания настоящих шедевров.",
    link: "/price?category=63&product=1367",
    btn: "Узнать больше",
    light: false,
  },
  {
    type: "video",
    src: Xiaomi15,
    title: "Xiaomi 15",
    description:
      "Грациозный дизайн и ультра объектив от Leica. Новое искусство фотографии.",
    link: "/price?category=63&product=1420",
    btn: "Узнать больше",
    light: true,
  },
  {
    type: "video",
    src: X20Pro,
    title: "Робот-пылесос XIAOMI X20 Pro",
    description: "Автоматическая мойка, быстрая сушка горячим воздухом.",
    link: "/price?category=6&product=1642",
    btn: "Узнать больше",
    light: false,
  },
  {
    type: "video",
    src: Watch2,
    title: "Часы Xiaomi Watch 2 Pro",
    description: "Интеллектуальные часы для активной жизни и стиля.",
    link: "/price?category=33&product=3250",
    btn: "Узнать больше",
    light: false,
    alignRight: true,
  },
  {
    type: "video",
    src: Redmi14,
    title: "Серия смартфонов Redmi Note 14",
    description: "Культовые снимки, созданные искусственным интеллектом.",
    link: "/price?category=63&product=1400",
    btn: "Узнать больше",
    light: false,
    alignRight: true,
  },
];

export default slides;
